import IconButton from '@material-ui/core/IconButton'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'
import React from 'react'

export default function Actions({ exclude, edit }) {
  return (
    <>
      <IconButton onClick={exclude} aria-label='delete'>
        <DeleteIcon />
      </IconButton>
      <IconButton onClick={edit} aria-label='edit'>
        <CreateIcon />
      </IconButton>
    </>
  )
}

Actions.propTypes = {
  exclude: PropTypes.func,
  edit: PropTypes.func,
}
